import { FC } from 'react'
import {
  OverlayParagraph,
  OverlaySubtitle,
  OverlayTitle,
  OverlayList
} from 'linkdrop-ui'

const PopupContents: FC = () => {
  return <>
    <OverlaySubtitle>Why do I need a wallet?</OverlaySubtitle>
    <OverlayParagraph>
      A crypto wallet is necessary to connect to a web3 service because it allows you to authenticate your identity and authorize your actions on the Ethereum blockchain.
    </OverlayParagraph>
    <OverlaySubtitle>Why is wallet connection required?</OverlaySubtitle>
    <OverlayParagraph>
      Connecting a crypto wallet to a website allows you to use your cryptocurrency and interact with the Ethereum blockchain in a convenient and secure manner.
    </OverlayParagraph>
    <OverlayTitle>Which wallet to choose?</OverlayTitle>
    <OverlaySubtitle>Metamask</OverlaySubtitle>
    <OverlayList>
      <li>Provides access to a wide range of decentralized applications (dApps)</li>
      <li>Offers a desktop browser extension that allows users to access their wallet from within their web browser.</li>
    </OverlayList>
    <OverlaySubtitle>Trust Wallet</OverlaySubtitle>
    <OverlayList>
      <li>Supports a wide range of cryptocurrencies and allows users to buy, sell, and manage their cryptocurrency.</li>
    </OverlayList>
    <OverlaySubtitle>Coinbase</OverlaySubtitle>
    <OverlayList>
      <li>Allows easy buying and selling of cryptocurrency.</li>
      <li>Provides access to professional support and customer service.</li>
      <li>Supports a limited range of cryptocurrencies.</li>
    </OverlayList>
  </>
}

export default PopupContents